/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { locationSummarySchema } from './locationSummarySchema';
import { skillSummarySchema } from './skillSummarySchema';
import { teamRoleSummarySchema } from './teamRoleSummarySchema';

export const membershipWithResourceAndSchemesResponseSchema = z.object({
  capacitySeconds: z.int().nullish(),
  commitment: z.number(),
  commitmentOverridden: z.boolean(),
  endDate: z.iso.date().nullish(),
  get location() {
    return z.union([locationSummarySchema, z.null()]).optional();
  },
  membershipId: z.int(),
  membershipSourceId: z.string().nullish(),
  openPositionId: z.int().nullish(),
  openPositionName: z.string().nullish(),
  resourceId: z.int().nullish(),
  resourceIsAnonymized: z.boolean(),
  resourceName: z.string().nullish(),
  resourceSourceId: z.string().nullish(),
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED']).nullish(),
  resourceType: z.enum(['RESOURCE', 'PLACEHOLDER']).nullish(),
  get role() {
    return z.union([teamRoleSummarySchema, z.null()]).optional();
  },
  get skills() {
    return z.array(skillSummarySchema);
  },
  sourceCommitment: z.number(),
  startDate: z.iso.date().nullish(),
});
